/**
 * Single source of truth for identity, contact and compliance.
 * Every page reads from here. Do not hardcode phone numbers, NMLS ids or
 * the brand name anywhere else.
 */
const site = {
  brand: "McDonald Home Loans",
  brandShort: "McDonald",
  tagline: "Independent mortgage broker. Denver, Colorado.",
  person: {
    name: "Justin McDonald",
    first: "Justin",
    title: "Independent Mortgage Broker",
    nmls: "1156016",
    nmlsUrl: "https://www.nmlsconsumeraccess.org/EntityDetails.aspx/INDIVIDUAL/1156016",
  },
  company: {
    legalName: "McDonald Home Loans",
    // Set once the brokerage's company NMLS id is issued. Footer hides it while null.
    nmls: null,
  },
  contact: {
    phone: "(720) 212-8443",
    phoneRaw: "+17202128443",
    email: "justin@mcdonaldhomeloans.com",
    city: "Denver",
    state: "CO",
    // Street address is intentionally omitted until the new office is set.
    address: null,
    hours: "Monday to Friday, 8am to 6pm. Evenings and weekends by text.",
  },
  social: {
    linkedin: "https://www.linkedin.com/in/mcdonaldhomeloans/",
    facebook: "https://www.facebook.com/mcdonaldhomeloans/",
    instagram: "https://www.instagram.com/the.justin.mcdonald_/",
  },
  reviews: {
    rating: 4.95,
    count: 330,
    source: "Experience.com",
    url: "https://www.experience.com/reviews/justin-mcdonald-348322",
  },
  proof: {
    volumeClosed: "$500M+",
    volumeClosedLong: "Nearly half a billion dollars in closed loans",
    yearsInMortgage: 12,
    since: 2014,
    referralPct: "100%",
    awards: [
      {
        name: "Top 1% of Mortgage Originators in America",
        by: "Mortgage Executive Magazine",
        detail: "Four consecutive years",
      },
      { name: "Top Originator", by: "Scotsman Guide", detail: "2026" },
      { name: "Top Mortgage Lenders", by: "Scotsman Guide", detail: "2025" },
    ],
  },
  licensedStates: ["CO", "KS", "MO", "NC", "SD", "VA", "WY"],
  licensedStateNames: [
    "Colorado",
    "Kansas",
    "Missouri",
    "North Carolina",
    "South Dakota",
    "Virginia",
    "Wyoming",
  ],
  serviceAreas: [
    "Denver",
    "Greenwood Village",
    "Highlands Ranch",
    "Littleton",
    "Lakewood",
    "Centennial",
    "Aurora",
    "Castle Rock",
    "Parker",
    "Arvada",
    "Golden",
    "Boulder",
    "Fort Collins",
  ],
  // Outbound application link. Replace with the broker's point-of-sale URL when live.
  applyUrl: "/contact/",
  compliance: {
    equalHousing: "Equal Housing Opportunity",
    disclaimer:
      "This is not a commitment to lend or an offer to extend credit. All loans are subject to credit approval, underwriting guidelines and property appraisal. Rates, fees, terms and program availability are subject to change without notice. Calculator results are estimates for illustration only and do not include every cost of homeownership.",
    licensing:
      "Justin McDonald, NMLS 1156016, is licensed as a mortgage loan originator in Colorado, Kansas, Missouri, North Carolina, South Dakota, Virginia and Wyoming. Regulated by the Colorado Division of Real Estate.",
  },
};

export default site;
